// packages/compose/src/higher-order/compose.ts
import { basePipe } from "./pipe.mjs";
var compose = basePipe(true);
var compose_default = compose;
export {
  compose_default as default
};
//# sourceMappingURL=compose.mjs.map
